import { WebTrackerResolutionType } from "../types";
import { FreshpaintSDK } from "../../typings/global";
import { FPEnvironmentLocker } from "../../reducers/environments";

export default class ProductEventEmitter {
  private readonly fp: FreshpaintSDK;
  private readonly envLocker: FPEnvironmentLocker;

  constructor(fp: FreshpaintSDK, envLocker: FPEnvironmentLocker) {
    this.fp = fp;
    this.envLocker = envLocker;
  }

  public async trackBAAUploaded(
    trackerName: string,
    trackerDomain: string
  ): Promise<void> {
    return new Promise((resolve) => {
      this.fp.track(
        "fp_wtm__baa_uploaded",
        {
          trackerName,
          trackerDomain,
          envID: this.envLocker.getEnvID(),
        },
        undefined,
        resolve
      );
    });
  }

  public async trackNoteSaved(
    trackerName: string,
    trackerDomain: string,
    note: string
  ): Promise<void> {
    return new Promise((resolve) => {
      this.fp.track(
        "fp_wtm__note_saved",
        {
          trackerName,
          trackerDomain,
          note,
          envID: this.envLocker.getEnvID(),
        },
        undefined,
        resolve
      );
    });
  }

  public async trackFPIntegrationConfirmed(
    trackerName: string,
    trackerDomain: string
  ): Promise<void> {
    return new Promise((resolve) => {
      this.fp.track(
        "fp_wtm__fp_integration_confirmed",
        {
          trackerName,
          trackerDomain,
          envID: this.envLocker.getEnvID(),
        },
        undefined,
        resolve
      );
    });
  }

  public async trackResolutionChanged(
    trackerName: string,
    trackerDomain: string,
    oldResolutionType: WebTrackerResolutionType,
    newResolutionType: WebTrackerResolutionType
  ): Promise<void> {
    return new Promise((resolve) => {
      this.fp.track(
        "fp_wtm__resolution_changed",
        {
          trackerName,
          trackerDomain,
          oldResolutionType,
          newResolutionType,
          envID: this.envLocker.getEnvID(),
        },
        undefined,
        resolve
      );
    });
  }
}
